// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"612e2fc6","104":"442b7864","133":"f101842d","418":"02b08df3","453":"f82db826","695":"7040836b","737":"f2bacfd6","857":"886ac2fd"}[chunkId] + ".chunk.js";
};